import { ErrorPopup } from "../utilities/swal";



type Response = {
  success: boolean;
  message: string;
  data?: any;
};
export function errorApi(
  title: string,
  message: string,
  showMessage: boolean = true
): Response {
  if (showMessage) {
    ErrorPopup(title, message);
  }
  return {
    success: false,
    message: message,
  };
}

export function successApi(data: any, message?: string): Response {
  return {
    success: true,
    message: message ? message : "Thành công",
    data: data,
  };
}
